import Header from 'components/headers/funds'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import Funds from 'modules/funds'
import useGatewayReturn from 'utilities/analytics/useGatewayReturn'

export default function FundsPage() {
    // Also the page the bank returns a payer to: `/funds/?result=…`. It is
    // where every v2 gateway lands them now, because this screen renders the
    // same on every bundle ever shipped — the service worker keeps old ones
    // alive for days, and a route only the newest bundle can render would show
    // those users a blank page. A no-op on the ordinary visits, which is
    // nearly all of them.
    useGatewayReturn()

    return (
        <>
            <Header title="صندوق‌ها" />
            <SideBar>
                <SideBarItems />
            </SideBar>
            <Funds />
        </>
    )
}
